export const SUPPORTED_LANGUAGES = ['en', 'ru', 'es'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export type ApiLanguage = 'EN' | 'RU' | 'ES'

export type UserPreferredLanguageEnum = {
  En: 'EN'
  Es: 'ES'
  Ru: 'RU'
}

const API_TO_UI: Record<string, SupportedLanguage> = {
  EN: 'en',
  RU: 'ru',
  ES: 'es',
}

const UI_TO_API: Record<SupportedLanguage, ApiLanguage> = {
  en: 'EN',
  ru: 'RU',
  es: 'ES',
}

const BROWSER_LOCALE_TO_LANGUAGE: Record<string, SupportedLanguage> = {
  en: 'en',
  ru: 'ru',
  es: 'es',
}

export function apiLanguageToUi(
  apiLanguage: string | null | undefined,
): SupportedLanguage | null {
  if (!apiLanguage) {
    return null
  }

  return API_TO_UI[apiLanguage] ?? null
}

export function uiLanguageToApi(language: SupportedLanguage): ApiLanguage {
  return UI_TO_API[language]
}

export function browserLocaleToLanguage(locale: string): SupportedLanguage {
  const normalized = locale.toLowerCase().slice(0, 2)

  return BROWSER_LOCALE_TO_LANGUAGE[normalized] ?? 'en'
}

export function resolveLanguage({
  apiLanguage,
  browserLocale,
}: {
  apiLanguage: string | null | undefined
  browserLocale: string
}): SupportedLanguage {
  return apiLanguageToUi(apiLanguage) ?? browserLocaleToLanguage(browserLocale)
}
